module.exports = __webpack_public_path__ + "img/KNDC.a244a71f.png";